var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cat",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 201,
    height: 184,
    viewBox: "0 0 201 184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    width: 201,
    height: 142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H26.994V54.988H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_70",
    "data-name": "Clip 70",
    d: "M0,272.824H182.385V0H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-3",
    "data-name": "Clip 2",
    d: "M0,0H70.68V81H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask-2",
    "data-name": "Mask",
    width: 201,
    height: 142,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73-2",
    "data-name": "Group 73",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73-3",
    "data-name": "Group 73",
    transform: "translate(9.74 10.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(100.052 217.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-5",
    "data-name": "Clip 2",
    d: "M0,0H26.994V54.988H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M14.071,0V34.818S26.4,38.428,26.994,46.071c0,0-6.773-4.746-10.351-3.9,0,0,1.007,8.355.212,12.814,0,0-5.794-11.043-8.18-11.892,0,0-5.214,1.277-8.322,8.708,0,0-2.93-13.052,8.113-16.024L4.3,0Z",
    fill: "#58b898"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(54.455 217.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_5",
    "data-name": "Clip 5",
    d: "M0,0H26.994V54.988H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-2",
    "data-name": "Group 6",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M12.923,0V34.818S.6,38.428,0,46.071c0,0,6.773-4.746,10.351-3.9,0,0-1.007,8.355-.212,12.814,0,0,5.794-11.043,8.18-11.892,0,0,5.214,1.277,8.322,8.708,0,0,2.93-13.052-8.113-16.024L22.693,0Z",
    fill: "#58b898"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M56.483.011V0c-.11,0-.22,0-.329,0s-.221,0-.331,0V.011c-32.626,0-88.231,85-31.252,182.543a191.035,191.035,0,0,1,5.656-19.532s2.477,16.56,8.516,21.656c0,0,1.751-14.72,4.167-20.665,0,0,3.777,20.665,6.522,24.345,0,0,5.372-20.6,6.719-23.979,1.316,3.374,4.718,23.979,4.718,23.979,2.747-3.68,8.524-24.345,8.524-24.345,2.416,5.945,4.168,20.665,4.168,20.665,6.04-5.1,8.515-21.656,8.515-21.656a190.891,190.891,0,0,1,5.657,19.532C144.714,85.009,87.738.011,56.483.011",
    transform: "translate(34.76 64.085)",
    fill: "#113c61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    d: "M57.942.011V0c-.11,0-.22,0-.329,0s-.22,0-.33,0V.011c-39.618.926-88.231,85-31.252,182.543,0,0-44.568-138.424,31.911-138.424S89.195,182.553,89.195,182.553C146.173,85.009,97.562.936,57.942.011",
    transform: "translate(33.3 64.085)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_11",
    "data-name": "Fill 11",
    d: "M23.529,0c0,5.935-5.268,10.747-11.765,10.747S0,5.935,0,0C0,0,4.871,6.186,11.764,6.186,18.639,6.186,23.529,0,23.529,0",
    transform: "translate(78.944 128.44)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_13",
    "data-name": "Fill 13",
    d: "M23.529,0c0,5.935-5.268,10.747-11.765,10.747S0,5.935,0,0C0,0,4.871,6.186,11.764,6.186,18.639,6.186,23.529,0,23.529,0",
    transform: "translate(78.944 166.2)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_15",
    "data-name": "Fill 15",
    d: "M23.529,0c0,5.935-5.268,10.747-11.765,10.747S0,5.935,0,0C0,0,4.871,6.186,11.764,6.186,18.639,6.186,23.529,0,23.529,0",
    transform: "translate(111.906 166.2)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_17",
    "data-name": "Fill 17",
    d: "M23.529,0c0,5.935-5.268,10.747-11.765,10.747S0,5.935,0,0C0,0,4.871,6.186,11.764,6.186,18.639,6.186,23.529,0,23.529,0",
    transform: "translate(45.847 166.2)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_19",
    "data-name": "Fill 19",
    d: "M23.529,0c0,5.935-5.268,10.747-11.765,10.747S0,5.935,0,0C0,0,4.871,6.186,11.764,6.186,18.639,6.186,23.529,0,23.529,0",
    transform: "translate(94.721 147.123)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_21",
    "data-name": "Fill 21",
    d: "M23.529,0c0,5.935-5.268,10.747-11.765,10.747S0,5.935,0,0C0,0,4.871,6.186,11.764,6.186,18.639,6.186,23.529,0,23.529,0",
    transform: "translate(61.624 147.123)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_23",
    "data-name": "Fill 23",
    d: "M23.529,0c0,5.935-5.268,10.747-11.765,10.747S0,5.935,0,0C0,0,4.871,6.186,11.764,6.186,18.639,6.186,23.529,0,23.529,0",
    transform: "translate(94.721 186.754)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_25",
    "data-name": "Fill 25",
    d: "M23.529,0c0,5.935-5.268,10.747-11.765,10.747S0,5.935,0,0C0,0,4.871,6.186,11.764,6.186,18.639,6.186,23.529,0,23.529,0",
    transform: "translate(61.624 186.754)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_27",
    "data-name": "Fill 27",
    d: "M40.008,1.969S-2.269,21.724.1,68.937c0,0,5.335-11.66,12.862-19.538,0,0-8.9,26.706,18.277,56.867,0,0-2.43-27.866,6.123-45.376C46.015,43.164,49.209,30.5,58.317,25.277,82.375,11.471,68.338-5.906,40.008,1.969",
    transform: "translate(0 92.674)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_29",
    "data-name": "Fill 29",
    d: "M30.649,1.923S72.927,21.678,70.562,68.891c0,0-5.335-11.66-12.862-19.538,0,0,8.9,26.706-18.277,56.867,0,0,2.43-27.866-6.123-45.376-8.657-17.726-11.931-29.8-21.039-35.021C-11.8,12.017,2.319-5.952,30.649,1.923",
    transform: "translate(111.728 92.72)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_31",
    "data-name": "Fill 31",
    d: "M0,42.179C9.386,17.614,34.872,0,64.84,0c29.45,0,54.572,17.011,64.339,40.911,0,0-31.418-10.022-64.339-9.746C31.844,31.441,0,42.179,0,42.179",
    transform: "translate(26.119 30.298)",
    fill: "#0f3c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_33",
    "data-name": "Fill 33",
    d: "M0,17.588s10.15,19.6,56.012,19.6S110.938,17.77,110.938,17.77,108.686,0,56.24,0,0,17.588,0,17.588",
    transform: "translate(34.468 64.086)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_35",
    "data-name": "Fill 35",
    d: "M0,39.647A38.059,38.059,0,0,1,10.744,23.018c8.085-7.043,19.971-9.76,27.95-11.4C46.185,10.074,64.369,7.653,68.5,0c0,0,2.928,18.793-13.587,24.92C34.974,32.317,12.9,24.3,0,39.647",
    transform: "translate(95.837 6.439)",
    fill: "#0f3c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_37",
    "data-name": "Fill 37",
    d: "M0,46.086s1.862-6.781,8.511-14.523S23.558,20.319,35.057,17.927C45.492,15.758,55.09,7.906,57.969,0c0,0,6.2,15.275-8.428,23.043C31.887,32.419,10.091,29.729,0,46.086",
    transform: "translate(95.837)",
    fill: "#0f3c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_39",
    "data-name": "Fill 39",
    d: "M0,33.258S3.163,21.815,12.443,15.407s19-6.645,26.85-5.936S72.65,8.219,74.652,0c0,0,2.83,18.109-15.942,24.618S15.417,18.545,0,33.258",
    transform: "translate(95.837 12.828)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_43",
    "data-name": "Stroke 43",
    d: "M64.975,32.562A32.488,32.488,0,1,1,32.488,0,32.488,32.488,0,0,1,64.975,32.562Z",
    transform: "translate(94.678 22.351)",
    fill: "none",
    stroke: "#58b898",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_47",
    "data-name": "Fill 47",
    d: "M65.093,32.621s-1.888-4.978-32.5-4.978S0,32.621,0,32.621a32.547,32.547,0,1,1,65.094,0",
    transform: "translate(94.608 22.247)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_49",
    "data-name": "Fill 49",
    d: "M68.7,39.647A38.059,38.059,0,0,0,57.951,23.018c-8.085-7.043-19.971-9.76-27.95-11.4C22.511,10.074,4.327,7.653.2,0c0,0-2.928,18.793,13.587,24.92,19.934,7.4,42.005-.619,54.908,14.727",
    transform: "translate(16.116 6.439)",
    fill: "#0f3c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_51",
    "data-name": "Fill 51",
    d: "M59.274,46.086s-1.862-6.781-8.511-14.523S35.716,20.319,24.217,17.927C13.782,15.758,4.184,7.906,1.3,0c0,0-6.2,15.275,8.428,23.043,17.654,9.376,39.451,6.686,49.542,23.043",
    transform: "translate(25.537)",
    fill: "#0f3c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_53",
    "data-name": "Fill 53",
    d: "M74.8,33.258S71.641,21.815,62.361,15.407s-19-6.645-26.85-5.936S2.154,8.219.152,0c0,0-2.83,18.109,15.942,24.618s43.294-6.073,58.711,8.64",
    transform: "translate(10.007 12.828)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_57",
    "data-name": "Stroke 57",
    d: "M0,32.562A32.488,32.488,0,1,0,32.488,0,32.488,32.488,0,0,0,0,32.562Z",
    transform: "translate(20.995 22.351)",
    fill: "none",
    stroke: "#58b898",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_61",
    "data-name": "Fill 61",
    d: "M29.809,27.731c5.466.108,23.641,4.039,32.432,3.942,5.926-.066,4.227-4.159,4.227-4.159A32.577,32.577,0,0,0,34.319,0C19.887,0,4.264,16.059,0,29.095c0,0,20.658-1.545,29.809-1.364",
    transform: "translate(19.208 22.293)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_63",
    "data-name": "Fill 63",
    d: "M9.9,34.57,0,22.456,9.835,0l9.9,22.525Z",
    transform: "translate(80.598 49.889)",
    fill: "#0f3c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_65",
    "data-name": "Fill 65",
    d: "M2.569,0c.29-.16,6.074,5.787,6.074,5.787L0,2.9S-.074,1.464,2.569,0",
    transform: "translate(44.84 51.07)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_67",
    "data-name": "Fill 67",
    d: "M2.569,0c.29-.16,6.074,5.787,6.074,5.787L0,2.9S-.074,1.464,2.569,0",
    transform: "translate(117.712 51.07)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Clip_70-2",
    "data-name": "Clip 70",
    d: "M0,272.824H182.385V0H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_69",
    "data-name": "Fill 69",
    d: "M0,4.794H20.919V0H0Z",
    transform: "translate(45.847 82.682)",
    fill: "#58b898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_71",
    "data-name": "Fill 71",
    d: "M0,4.794H20.919V0H0Z",
    transform: "translate(115.015 82.682)",
    fill: "#58b898"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-3",
    "data-name": "Group 3",
    transform: "translate(11.553 40.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.536,4.521c-4.828,16.79-1.28,27.318-1.28,27.318a38.884,38.884,0,0,0,8.6,3.728l4.1.585.707.516.109.082.048.035a115.908,115.908,0,0,0,27.474.758c11.838-.585,12.052-5.118,13.668-9A183.423,183.423,0,0,0,60.5,9.956C33.148-8.644,2.536,4.521,2.536,4.521Z",
    transform: "translate(8.215 4.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,9.956A181.788,181.788,0,0,0,4.534,28.538c1.622,3.885,1.843,8.44,13.662,9s28.239,1.886,41.046-5.7c0,0,3.548-10.553-1.28-27.318C57.962,4.521,27.346-8.644,0,9.956Z",
    transform: "translate(89.222 4.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M117.783,47.234h0c-3.74,0-7.259-.136-10.336-.259l-1.527-.06C91.879,46.389,89.3,38.648,88.326,35.736s-2.708-7.589-2.9-8.116a24.54,24.54,0,0,0-2.951-6.132,4.756,4.756,0,0,0-3.424-2.268H78.99a4.974,4.974,0,0,0-3.5,2.277,24.577,24.577,0,0,0-2.951,6.119c-.2.543-1.957,5.261-2.9,8.119-.972,2.918-3.55,10.668-17.6,11.179l-1.5.054c-1.376.054-2.84.1-4.38.148-1.894.069-3.812.1-5.715.1H38.332a65.124,65.124,0,0,1-27.668-5.268,30.549,30.549,0,0,1-9.443-6.99C1.2,34.945-1.266,32.885.877,7.316A83.284,83.284,0,0,1,35.122,0a74.318,74.318,0,0,1,36.2,9.2c.025,0,3.629.158,7.672.315,4.065-.148,7.666-.315,7.666-.315A74.328,74.328,0,0,1,122.849,0,83.669,83.669,0,0,1,157.1,7.316c2,23.7.085,27.178-.316,27.632C146.872,45.963,129.779,47.234,117.783,47.234ZM122.94,4.272a56.512,56.512,0,0,0-32.781,9.987A189.569,189.569,0,0,0,94.628,32.91c.177.432.341.883.5,1.318,1.288,3.542,2.616,7.208,12.977,7.712l2.159.107c3.26.167,6.943.353,10.68.353,7.464,0,18.45-.631,27.646-6.189.032-.1,3.449-10.725-1.262-27.405A67.66,67.66,0,0,0,122.94,4.272ZM35,4.272A67.467,67.467,0,0,0,10.6,8.811c-4.709,16.633-1.284,27.3-1.262,27.405a37.762,37.762,0,0,0,8.483,3.738,46.274,46.274,0,0,0,4.895,1.224A73.855,73.855,0,0,0,37.025,42.4c3.734,0,7.4-.189,10.636-.353l2.159-.107c10.367-.5,11.7-4.167,12.984-7.712.158-.432.316-.883.5-1.319a189.179,189.179,0,0,0,4.481-18.652A56.512,56.512,0,0,0,35,4.272Z",
    transform: "translate(-0.002 0)",
    fill: "#103c61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M-6384.921-1343.517c.211-4.445-5.828-9.992-5.828-9.992a7.4,7.4,0,0,0-10.387.926,23.761,23.761,0,0,0-6.04,12.688c.4,2.777,5.351.69,6.037-2.24a16.848,16.848,0,0,1,3.968-8.281c1.553-.863,6.045,6.9,6.045,6.9S-6387.066-1337.789-6384.921-1343.517Z",
    transform: "translate(6432.887 1370.005)",
    fill: "#103c61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M7239.352,1744.248h0c-.931,0-1.812-.7-2.626-2.089-.959-4.3,3.948-10.789,4-10.852a8.7,8.7,0,0,1,5.759-2.723,7.174,7.174,0,0,1,4.614,1.833l.572.49h0a23.461,23.461,0,0,1,7.569,10.943,1.467,1.467,0,0,1-.378,1.1,1.982,1.982,0,0,1-1.466.5,5.309,5.309,0,0,1-4.5-2.763c-1.134-2.661-3.623-6.875-5.337-7.467a.515.515,0,0,0-.172-.029c-1.678,0-4.544,7.8-4.576,7.875S7241.3,1744.248,7239.352,1744.248Z",
    transform: "translate(-7127.084 -1713.763)",
    fill: "#103c61"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(10 103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-4",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-6",
    "data-name": "Clip 2",
    d: "M0,0H70.68V81H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-5",
    "data-name": "Group 3",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1-2",
    "data-name": "Fill 1",
    d: "M40.053,1.5S-2.272,16.559.1,52.547c0,0,5.341-8.888,12.877-14.893,0,0-8.906,20.356,18.3,43.346,0,0-2.432-21.24,6.13-34.588C46.066,32.9,49.264,23.251,58.382,19.267,82.467,8.743,68.415-4.5,40.053,1.5",
    fill: "#58b898"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-3",
    "data-name": "Group 6",
    transform: "translate(111.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_5-2",
    "data-name": "Clip 5",
    d: "M0,0H70.68V81H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-4",
    "data-name": "Group 6",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4-2",
    "data-name": "Fill 4",
    d: "M30.659,1.466S72.95,16.531,70.584,52.535c0,0-5.337-8.892-12.866-14.9,0,0,8.9,20.365-18.283,43.365,0,0,2.43-21.25-6.125-34.6C24.65,32.883,21.376,23.68,12.265,19.694-11.8,9.164,2.32-4.539,30.659,1.466",
    fill: "#58b898"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/cat.d49fc86f843a38ae8fb71aeea70f404d.svg";
export { ForwardRef as ReactComponent };